import { Pipe, PipeTransform } from '@angular/core';
import {Destination} from '../models/program-article-translation';
import {User} from '../models/user';

@Pipe({
  name: 'filterByDestination'
})
export class FilterByDestinationPipe implements PipeTransform {

  transform(Destinations: Destination[], user: User): Destination[] {
    if (!user) {
      return [];
    } else {
      return Destinations.filter(t => t.value.translations.find(t => t.language.id === user.currentLanguage.id));
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/filter-by-destination.pipe.ts